<section>


    <article class="card container-fluid">
        <h2 class="card-header text-center font-weight-bold text-uppercase py-4">Properties</h2>
        <div class="card-body" style="overflow-x:auto;">
            <div class="text-center top-text">

                <h5>This tool helps informs the rental market place about who has received either renter or housing provider education. For more detailed information about specific units contact the owner/manager, your local housing authority, access local
                    resources or visit <strong><a target="_blank" href="https://housing.ne.gov/">housing.ne.gov</a></strong> </h5>
            </div>
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th></th>
                        <th>Entry Date</th>
                        <th>For Rent</th>
                        <th>Owner Name</th>
                        <th>Manager Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>ZipCode</th>
                        <th>Building #</th>
                        <th>Building Units</th>
                        <th>Available Units</th>
                        <th>Property Note</th>
                        <th>Housing Vouchers Acceptance</th>
                        <th>Voucher Note</th>
                        <th>Certified Units?</th>
                        <th>Certified Unit Provider</th>
                        <th># Certified Units</th>
                        <th>Certified Unit Note</th>
                        <th>Lead Safe Units?</th>
                        <th>Lead Safe Provider</th>
                        <th># Lead Safe Units</th>
                        <th>Lead Safe Note</th>
                        <th>Building ADA Accessible</th>
                        <th>Unit ADA Accessible</th>
                        <th>Accessible Note</th>
                        <th>Incentive for Rentwise</th>
                        <th>Incentive Note</th>
                        <th *ngIf="auth.user && canChallenge">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let property of properties">
                        <td class="td-status">
                          <mdb-icon *ngIf="property.challenged" fas icon="exclamation-triangle" class="text-warning"
                            [matTooltip]="tooltipChallenging(property)" matTooltipPosition="above">
                          </mdb-icon>
                        </td>
                        <td class="text-nowrap" [attr.data-sort]="sortDate(property.entryDate)">{{ property.entryDate | date }}</td>
                        <td>{{ property.isAvailable ? 'Yes' : 'No' }}</td>
                        <td>{{ property.ownerName }}</td>
                        <td>{{ property.managerName }}</td>
                        <td>{{ property.contactPhone }}</td>
                        <td>{{ property.email }}</td>
                        <td>{{ property.address }}</td>
                        <td>{{ property.city }}</td>
                        <td>{{ property.zipCode }}</td>
                        <td>{{ property.buildingNumber ? property.buildingNumber : 1 }}</td>
                        <td>{{ property.buildingUnits ? property.buildingUnits : 1 }}</td>
                        <td>{{ property.availableUnits ? property.availableUnits : 0 }}</td>
                        <td>{{ property.propertyNote }}</td>
                        <td>{{ property.hcvCheck ? 'Yes' : 'No' }}</td>
                        <td>{{ property.hcvNote }}</td>
                        <td>{{ property.cuCheck ? 'Yes' : 'Info Unavailable' }}</td>
                        <td>{{ property.cuProvider }}</td>
                        <td>{{ property.cuUnits }}</td>
                        <td>{{ property.cuNote }}</td>
                        <td>{{ property.lsCheck ? 'Yes' : 'Info Unavailable' }}</td>
                        <td>{{ property.lsProvider }}</td>
                        <td>{{ property.lsUnits }}</td>
                        <td>{{ property.lsNote }}</td>
                        <td>{{ property.buildingAdaAccessible | boolean:'Yes':'No' }}</td>
                        <td>{{ property.unitAdaAccessible | boolean:'Yes':'No' }}</td>
                        <td>{{ property.accessibleNote }}</td>
                        <td>{{ property.incentiveForRentwise | boolean:'Yes':'No' }}</td>
                        <td>{{ property.incentiveNote }}</td>
                        <td class="td-actions" *ngIf="auth.user && canChallenge">
                          <button type="button" class="btn-warning" (click)="challenge(property)" *ngIf="!property.ichallenged">Challenge</button>
                          <button type="button" class="btn-danger" (click)="discardChallenge(property)" *ngIf="property.ichallenged">Discard Challenge</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>

    <div class="bot-text text-center">
        <h4 style="font-weight: bolder">Notes:</h4>
        <p>Lead safe units are free of any lead-based paint hazards </p>
        <p>Certified units have been inspected, and meet the guidelines of the certifying partner</p>
        <p>If a property you own/manage was added without your permission, please inform the Nebraska Housing Developers Association
        </p>

    </div>
</section>
